exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-input-number__input[data-v-7c6dc8f0]{border-style:solid;border-width:0 0 1px 0;width:50px;height:1.4rem;line-height:1.7rem}@media (min-width: 768px){.base-input-number__input[data-v-7c6dc8f0]{height:1.7rem}}.base-input-number__label[data-v-7c6dc8f0]{font-size:0.8rem;line-height:1.2rem}@media (min-width: 768px){.base-input-number__label[data-v-7c6dc8f0]{font-size:1rem;line-height:1.4rem}}\n", ""]);

// exports
